"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyFlatten = void 0;
function* internalFlatten(src, depth) {
    if (depth < 0) {
        return yield src;
    }
    const isIterable = (item) => Symbol.iterator in Object(item);
    for (const currentItem of src) {
        if (isIterable(currentItem)) {
            yield* internalFlatten(currentItem, depth - 1);
        }
        else {
            yield currentItem;
        }
    }
}
function applyFlatten(factory, src, depth) {
    if (Number.isNaN(depth) || (typeof depth === 'number' && depth < 0)) {
        throw new Error('Invalid depth.');
    }
    function* generator() {
        yield* internalFlatten(src, depth !== null && depth !== void 0 ? depth : 1);
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyFlatten = applyFlatten;
//# sourceMappingURL=applyFlatten.js.map